module.exports = __webpack_public_path__ + "img/tarjetavecino.22518da6.png";